module.exports = __webpack_public_path__ + "img/StyleBangkok_375_506.d34ea2ad.jpeg";